import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-org-settings-communication-workflow',
  templateUrl: './org-settings-communication-workflow.component.html',
  styleUrls: ['./org-settings-communication-workflow.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSettingsCommunicationWorkflowComponent {}
